module.exports = __webpack_public_path__ + "img/MEDIA094.9814be56.jpg";